import { PopoverPanel } from '@headlessui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';
import React, { useEffect, useRef } from 'react';

import { AnimalType, PublicationType, BreedComponent, useScrollState } from '@/entities/filters';
import { Icons } from '@/shared/ui';

interface FilterPopoverProps {
  currentParams: URLSearchParams;
  breedData: Record<string, number> | null;
  isLoading: boolean;
  setIsOpen: (open: boolean) => void;
}

const FilterPopover: React.FC<FilterPopoverProps> = ({
  currentParams,
  breedData,
  isLoading,
  setIsOpen
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const { isTop, isBottom } = useScrollState(scrollContainerRef);

  useEffect(() => {
    setIsOpen(true);
    return () => setIsOpen(false);
  }, [setIsOpen]);

  return (
    <PopoverPanel static className="flex h-1/2 w-full flex-col gap-4 whitespace-nowrap">
      <section>
        <h4 className="text-xl">Тип животного:</h4>
        <AnimalType urlSearchParams={currentParams} />
      </section>
      <section>
        <h4 className="text-xl">Тип объявления:</h4>
        <PublicationType urlSearchParams={currentParams} />
      </section>

      <section className="relative flex h-3/5 flex-col">
        <h4 className="text-xl">Порода:</h4>
        <hr className="mt-1 h-0.5 border-t-0 bg-neutral-400 opacity-100 dark:bg-neutral-100 dark:opacity-50" />
        <div
          ref={scrollContainerRef}
          className="scrollbar-thumb-rounded-full h-full max-h-60 overflow-auto scrollbar-thin scrollbar-thumb-gray-400"
        >
          {isLoading ? (
            <div className="flex w-full items-center justify-center">
              <Icons.InfiniteLoadingDotsIcon className="text-blue-main dark:text-gray-300" />
            </div>
          ) : (
            breedData &&
            Object.entries(breedData).map(([breed, count]) => (
              <BreedComponent
                key={breed}
                breed={breed}
                count={count}
                urlSearchParams={currentParams}
              />
            ))
          )}
        </div>

        {/* Убедитесь, что состояние isTop и isBottom обновляется корректно */}
        {!isBottom && (
          <div className="absolute -bottom-8 right-0 flex justify-center">
            <ChevronDownIcon className="h-10 w-10 text-gray-300" />
          </div>
        )}
        {isBottom && !isTop && (
          <div className="absolute right-0 top-8 flex justify-center">
            <ChevronUpIcon className="h-10 w-10 text-gray-300" />
          </div>
        )}
      </section>
    </PopoverPanel>
  );
};

export default FilterPopover;
